// API Tier Identifiers
export const API_TIER_1 = 'tier_1'
export const API_TIER_2 = 'tier_2'
export const API_TIER_3 = 'tier_3'
export const API_TIER_4_ENTERPRISE = 'tier_4' // Enterprise tier

export const US_API_TIERS = {
  tier_1: {
    name: 'Tier 1',
    price: 29,
    calls: '1,000',
    overageCost: 0.05
  },
  tier_2: {
    name: 'Tier 2',
    price: 99,
    calls: '4,000',
    overageCost: 0.05
  },
  tier_3: {
    name: 'Tier 3',
    price: 199,
    calls: '10,000',
    overageCost: 0.05
  }
}

export const EURO_API_TIERS = {
  tier_1: {
    name: 'Tier 1',
    price: 29,
    calls: '1,000',
    overageCost: 0.05
  },
  tier_2: {
    name: 'Tier 2',
    price: 96,
    calls: '4,000',
    overageCost: 0.05
  },
  tier_3: {
    name: 'Tier 3',
    price: 192,
    calls: '10,000',
    overageCost: 0.05
  }
}
